import {ref, Ref} from 'vue';
import {SaveWarningResponse} from '../../../npm_module/NpmModuleApiController';

type Resolve = (response: SaveWarningResponse) => void;

export class EditorSaveWarningsControllerClass {
	private static _instance: EditorSaveWarningsControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorSaveWarningsControllerClass());
	}

	private constructor() {}

	private _displayed: Ref<boolean> = ref(false);
	private _resolve: Resolve | undefined;
	displayed() {
		return this._displayed.value;
	}
	display(): Promise<SaveWarningResponse> {
		return new Promise((resolve) => {
			this._displayed.value = true;
			this._resolve = resolve;
		});
	}
	skip() {
		this._displayed.value = false;
		if (this._resolve) {
			const callback = this._resolve;
			this._resolve = undefined;
			callback(SaveWarningResponse.SKIP);
		}
	}
	saveAgain() {
		this._displayed.value = false;
		if (this._resolve) {
			const callback = this._resolve;
			this._resolve = undefined;
			callback(SaveWarningResponse.SAVE_AGAIN);
		}
	}
}

export const SaveWarnings = EditorSaveWarningsControllerClass.instance();
